































































import {Vue, Component} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';

@Component({
    name: 'AboutMe',
    components: {AppLink},
})
export default class AboutMe extends Vue {

}
